import React from "react";
import { Modal, Row, Col } from "antd";
import momentTZ from "moment-timezone";

const RowForm = props => (
  <Row style={{ padding: " 5px 10px" }}>{props.children}</Row>
);

class ModalCustomerDetail extends React.Component {
  render() {
    const { data } = this.props;

    return (
      <Modal
        title="Detail Cabang"
        visible={this.props.visible}
        onOk={() => this.props.visibleModal()}
        onCancel={() => this.props.visibleModal()}
        width={700}>
        <p>Detail Customer</p>

        <RowForm>
          <Col span={8}>Email</Col>
          <Col span={16}>: {data ? data.email : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Nama</Col>
          <Col span={16}>
            : {data ? (data.userprofile ? data.userprofile.name : null) : null}
          </Col>
        </RowForm>
        <RowForm>
          <Col span={8}>No. HP</Col>
          <Col span={16}>
            : {data ? (data.userprofile ? data.userprofile.phone : null) : null}
          </Col>
        </RowForm>

        <RowForm>
          <Col span={8}>Jenis Kelamin</Col>
          <Col span={16}>
            :{" "}
            {data
              ? data.userprofile
                ? data.userprofile.gender == "L"
                  ? "Laki-laki"
                  : data.userprofile.gender == "P"
                  ? "Perempuan"
                  : null
                : null
              : null}
          </Col>
        </RowForm>

        <RowForm>
          <Col span={8}>Tempat Lahir</Col>
          <Col span={16}>
            :{" "}
            {data
              ? data.userprofile
                ? data.userprofile.place_of_birth
                : null
              : null}
          </Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Tanggal Lahir</Col>
          <Col span={16}>
            :{" "}
            {data
              ? data.userprofile
                ? data.userprofile.date_of_birth
                  ? momentTZ(data.userprofile.date_of_birth)
                      .tz("Asia/Jakarta")
                      .format("dddd, D MMMM YYYY")
                  : null
                : null
              : null}
          </Col>
        </RowForm>

        <RowForm>
          <Col span={8}>Tanggal Dibuat</Col>
          <Col span={16}>
            :{" "}
            {data
              ? momentTZ(data.created_at)
                  .tz("Asia/Jakarta")
                  .format("dddd, D MMMM YYYY HH:mm")
              : null}
          </Col>
        </RowForm>
      </Modal>
    );
  }
}

export default ModalCustomerDetail;



// WEBPACK FOOTER //
// src/components/Dashboard/B2C/Customer/Modal/ModalCustomerDetail.js